<template>
  <g
    id="Grupo_428"
    data-name="Grupo 428"
    transform="translate(-1426.186 -514.186)"
  >
    <path
      id="Trazado_3594"
      data-name="Trazado 3594"
      class="cls-1"
      d="M1441.949 514.286h2.088c.569.074 1.142.126 1.707.226a16.37 16.37 0 0 1 10.529 6.379 16.685 16.685 0 0 1-24.292 22.644 16.457 16.457 0 0 1-5.435-9.63c-.112-.618-.175-1.245-.26-1.867v-2.088c.073-.558.128-1.12.222-1.674a16.759 16.759 0 0 1 13.608-13.732c.607-.108 1.222-.174 1.833-.258zm15.663 16.7a14.618 14.618 0 1 0-14.629 14.625 14.64 14.64 0 0 0 14.629-14.624z"
    />
    <path
      id="Trazado_3596"
      data-name="Trazado 3596"
      class="cls-1"
      d="M1667.815 621.03c0 1.457.006 2.913-.005 4.37a.791.791 0 0 0 .253.626q3.3 3.276 6.576 6.568c.575.575.642 1.194.181 1.656s-1.074.406-1.655-.174q-3.483-3.482-6.968-6.96a1.512 1.512 0 0 1-.476-1.158c.012-3.141 0-6.283.008-9.424a1.042 1.042 0 0 1 1.346-1.072 1.058 1.058 0 0 1 .74 1.069q.003 2.249 0 4.499z"
      transform="translate(-223.778 -94.515)"
    />
  </g>
</template>
